<!--
 * @Description: 学校规章制度系统 模板
 * @Author: PF
 * @Date: 2023-02-02 13:28:24
 * @LastEditors: PF
 * @LastEditTime: 2024-10-22 10:40:06
-->

<template>
  <div class="zi-kuang-jia">
    <!-- 内容区域 -->
    <div class="content wp100">
        <router-view v-slot="{ Component }" :key="$route.query.t">
          <keep-alive v-if="$route.meta.keepAlive">
            <component :is="Component"></component>
          </keep-alive>
          <component v-if="!$route.meta.keepAlive" :is="Component" />
        </router-view>
    </div>
  </div>
</template>

<script setup>
</script>

<style lang='less' scoped>
.zi-kuang-jia {
  height: 100%;
  .kaiGuan {
    height: calc(100% - 45px);
    position: absolute;
    bottom: 0;
    z-index: 9;
    display: flex;
    align-items: center;
    .kaiGuanBut {
      height: 40px;
      width: 19px;
      border: 1px solid var(--frame_tone);
    }
  }
  .el-card + .el-card {
    margin-top: 10px;
  }
  .title {
    font-size: 20px;
    font-weight: bold;
  }

  // 内嵌导航
  .menu {
    width: 220px;
    height: calc(100% - 100px);
    background-color: var(--bg_nav);
    overflow: auto;
    position: fixed;
    transition: all 0.2s;
    :deep(.el-menu) {
      background-color: #393d49;
      border-right: none !important;
    }
    :deep(.el-sub-menu__title) {
      background-color: var(--bg_nav);
      color: var(--other_color);
    }
    :deep(.default_main_tone) {
      font-size: 16px;
    }
    :deep(.el-sub-menu__title:hover) {
      color: #fff;
      .default_main_tone {
        color: var(--select_main_tone) !important;
      }
    }
    .el-menu-item.is-active {
      background-color: var(--bg_blue);
      color: #fff;
    }
    .el-menu-item {
      background-color: var(--bg_black);
      color: var(--other_color);
      border-left: 3px solid #1e9eff00;
    }
    .el-menu-item:hover {
      color: #fff;
      border-left-color: #1e9eff;
    }
  }
  // @-webkit-keyframes slide-down{
  //   0%{transform: scale(1,0);}
  //   100%{transform: scale(1,1);}
  // }
  // //设置左侧菜单最大高度以及展开效果
  // .menu .el-sub-menu :deep(.el-menu) {
  //   max-height: calc(100vh - (56.4*10px)) !important;
  //   overflow: auto !important;
  //   transform-origin: 50% 0;
  //   -webkit-animation: slide-down .3s ease-in;
  //   transition: max-height .3s ease-out;
  // }

  // 框架
  .content {
    height: 100%;
    float: left;
    min-height: 100%;
    -webkit-transition: margin-left 0.28s;
    transition: margin-left 0.28s;
    position: relative;

    background-color: #fff;
    :deep(.el-tabs__header) {
      display: block;
      .el-tabs__item {
        transition: none;
      }
    }
    :deep(.el-tabs__item:nth-child(1)) {
      .el-icon {
        display: none;
      }
    }
    :deep(.el-tabs--border-card) {
      border: 0px;
    }
    :deep(.el-tabs__nav-scroll) {
      border-bottom: 0px;
    }
    // 标签
    .el-tabs {
      :deep(.el-tabs__content) {
        display: none;
      }
    }
    // 标签页内容区域
    .tab_nei_rong {
      height: calc(100% - 42px);
      .nei-rong {
        min-width: calc(1400px - 222px);
        min-height: calc(700px - 155px);
        height: 100%;
      }
    }
  }
  .subMenu :deep(.el-sub-menu__icon-arrow) {
    display: none;
  }
  .default_main_tone,
  .el-menu-item {
    font-size: 16px;
  }

  // //设置左侧菜单最大高度
  // .menu .el-sub-menu :deep(.el-menu) {
  //   max-height: calc(100vh - (56.4*10px)) !important;
  //   overflow: auto !important;
  // }
  // 右键菜单
  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: fixed; //关键样式设置固定定位
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
  }

  .contextmenu li {
    margin: 0;
    padding: 7px 16px;
    cursor: pointer;
    text-align: center;
  }
  .contextmenu li:hover {
    background: #eee;
  }
}
</style>
